import { render, staticRenderFns } from "./BindingSuccess.vue?vue&type=template&id=4b1715a8&"
import script from "./BindingSuccess.vue?vue&type=script&lang=js&"
export * from "./BindingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BindingSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports